// StockMaterial.js - List page with Mock Data (Frontend Only) + City Counts
import React, { useState, useEffect } from 'react';
import { FaBoxes, FaSearch, FaPlus, FaTrash, FaEdit, FaCheckDouble, FaEllipsisV, FaMapMarkerAlt } from 'react-icons/fa';
import { RiDeleteBin5Fill } from 'react-icons/ri';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { IoMdArrowDropdown } from "react-icons/io";
import api from '../../services/api';
import './StockMaterial.css';

// ============================================================
// 🔥 MOCK DATA - Backend ready hone tak yeh use hoga
// Backend ready hone ke baad yeh array hata dein
// ============================================================
const MOCK_STOCK_MATERIALS = [
  {
    id: 1,
    received_date: '2025-05-12',
    invoice_no: '37280',
    material_specification: '6/4 Grade 5 ELI Ti Bar - 6mm Dia x 3000mm r/s',
    supplier_name: 'TI-TEK-UK',
    reference_no: '6BATI64ELIJ',
    material_lot_num: '2407-3',
    internal_lot_number: 'A1',
    material_type: 'Titanium Bar',
    unit: 'Bar',
    quantity_received: 25,
    fault_pieces: 8,
    after_inspection_final_stock: 17,
    city: 'London',
    shop_id: 16,
  },
  {
    id: 2,
    received_date: '2025-06-03',
    invoice_no: '37561',
    material_specification: '6/4 Grade 5 ELI Ti Bar - 6mm Dia x 3000mm r/s',
    supplier_name: 'TI-TEK-UK',
    reference_no: '6BATI64ELIJ',
    material_lot_num: '2407-3',
    internal_lot_number: 'A2',
    material_type: 'Titanium Bar',
    unit: 'Bar',
    quantity_received: 20,
    fault_pieces: 0,
    after_inspection_final_stock: 20,
    city: 'Manchester',
    shop_id: 16,
  },
  {
    id: 3,
    received_date: '2025-06-03',
    invoice_no: '37561',
    material_specification: '6/4 Grade 5 ELI Ti Bar - 10mm Dia x 3000mm r/s',
    supplier_name: 'TI-TEK-UK',
    reference_no: '6BATI64ELIJ',
    material_lot_num: '2210-2',
    internal_lot_number: 'A3',
    material_type: 'Titanium Bar',
    unit: 'Bar',
    quantity_received: 30,
    fault_pieces: 0,
    after_inspection_final_stock: 30,
    city: 'Birmingham',
    shop_id: 16,
  },
  {
    id: 4,
    received_date: '2025-07-02',
    invoice_no: '37935',
    material_specification: '6/4 Grade 5 ELI Ti Bar - 6mm Dia x 3000mm r/s',
    supplier_name: 'TI-TEK-UK',
    reference_no: '6BATI64ELIJ',
    material_lot_num: '2407-3',
    internal_lot_number: 'A4',
    material_type: 'Titanium Bar',
    unit: 'Bar',
    quantity_received: 30,
    fault_pieces: 0,
    after_inspection_final_stock: 30,
    city: 'London',
    shop_id: 16,
  },
];

// city compare helper (case-insensitive, trimmed)
const normCity = (c) => String(c || '').trim().toLowerCase();

const StockMaterial = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { shopId: urlShopId } = useParams();

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [showActionDropdown, setShowActionDropdown] = useState(false);
  const [materials, setMaterials] = useState([]);
  const [shops, setShops] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  const [selectedShop, setSelectedShop] = useState(() => {
    return localStorage.getItem('selectedShopId') || urlShopId || '';
  });
  const [currentShopName, setCurrentShopName] = useState('');

  // ==========================================
  // HEADER CITY DROPDOWN
  // ==========================================
  const [headerCities, setHeaderCities] = useState([]);
  const [headerCity, setHeaderCity] = useState('');
  const [loadingHeaderCities, setLoadingHeaderCities] = useState(false);

  // ==========================================
  // INITIAL LOAD
  // ==========================================
  useEffect(() => {
    fetchShops();
  }, []);

  useEffect(() => {
    const match = location.pathname.match(/\/shop\/(\d+)/);
    if (match) {
      const shopIdFromUrl = match[1];
      if (selectedShop !== shopIdFromUrl) {
        setSelectedShop(shopIdFromUrl);
        localStorage.setItem('selectedShopId', shopIdFromUrl);
      }
    } else {
      const storedShopId = localStorage.getItem('selectedShopId');
      if (storedShopId && selectedShop !== storedShopId) {
        setSelectedShop(storedShopId);
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (selectedShop) {
      setDataLoaded(false);
      fetchMaterials();
      fetchShopName();
      fetchHeaderCities();
    }
  }, [selectedShop]);

  useEffect(() => {
    const handleShopChangeEvent = (e) => {
      if (e.detail && e.detail.shopId) {
        const newShopId = e.detail.shopId.toString();
        setSelectedShop(newShopId);
        localStorage.setItem('selectedShopId', newShopId);
      }
    };
    window.addEventListener('shopChanged', handleShopChangeEvent);
    return () => window.removeEventListener('shopChanged', handleShopChangeEvent);
  }, []);

  const fetchShops = async () => {
    try {
      const response = await api.get('/user/shops/');
      setShops(response.data);
    } catch (error) {
      console.error('Error fetching shops:', error);
    }
  };

  const fetchShopName = async () => {
    try {
      const res = await api.get(`/api/product/shops/${selectedShop}/`);
      if (res.data) setCurrentShopName(res.data.shop_name || '');
    } catch (err) {
      // fallback
    }
  };

  // Header city dropdown ke liye cities (fail ho to materials ki cities use hongi)
  const fetchHeaderCities = async () => {
    try {
      setLoadingHeaderCities(true);
      const response = await api.get(`/inventory/shop-cities/?shop_id=${selectedShop}`);
      let citiesData = [];
      if (response.data) {
        if (Array.isArray(response.data.cities)) {
          citiesData = response.data.cities;
        } else if (Array.isArray(response.data)) {
          citiesData = response.data;
        }
      }
      setHeaderCities(citiesData);
    } catch (error) {
      setHeaderCities([]);
    } finally {
      setLoadingHeaderCities(false);
    }
  };

  // ==========================================
  // 🔥 FETCH MATERIALS - poora shop ka data (city filter frontend par), Mock fallback
  // ==========================================
  const fetchMaterials = async () => {
    try {
      const url = `/inventory/stock-material/?shop_id=${selectedShop}`;
      const response = await api.get(url);
      const records = Array.isArray(response.data) ? response.data : [];
      setMaterials(records);
      setDataLoaded(true);
    } catch (error) {
      // 🔥 BACKEND 404 → use mock data (frontend only mode)
      console.warn('⚠️ Backend not ready, using mock data');
      setMaterials(MOCK_STOCK_MATERIALS);
      setDataLoaded(true);
    }
  };

  // Dropdown ki cities: API se, warna materials ki unique cities
  const displayCities =
    headerCities.length > 0
      ? headerCities
      : [...new Set(materials.map((m) => m.city).filter(Boolean))];

  // Agar selected city list mein nahi rahi (shop change) to All Cities par wapas
  useEffect(() => {
    if (headerCity !== '' && !displayCities.includes(headerCity)) {
      setHeaderCity('');
    }
  }, [displayCities.join('|')]);

  // ✅ Count of records per city (always from full shop data)
  const cityCounts = materials.reduce((acc, m) => {
    if (m.city) {
      const key = normCity(m.city);
      acc[key] = (acc[key] || 0) + 1;
    }
    return acc;
  }, {});

  const totalCount = materials.length;
  const isAllCities = !headerCity;
  const selectedCityCount = isAllCities ? totalCount : (cityCounts[normCity(headerCity)] || 0);
  const selectedCityLabel = isAllCities ? 'All Cities' : headerCity;

  // ==========================================
  // SEARCH & SELECT (city + search)
  // ==========================================
  const filteredMaterials = materials.filter((m) => {
    if (!isAllCities && normCity(m.city) !== normCity(headerCity)) {
      return false;
    }
    const term = searchTerm.toLowerCase();
    return (
      m.material_specification?.toLowerCase().includes(term) ||
      m.invoice_no?.toLowerCase().includes(term) ||
      m.supplier_name?.toLowerCase().includes(term) ||
      m.material_lot_num?.toLowerCase().includes(term)
    );
  });

  const handleSelectAll = () => {
    if (selectedItems.length === filteredMaterials.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(filteredMaterials.map((m) => m.id));
    }
    setShowActionDropdown(false);
  };

  const handleSelectItem = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((x) => x !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
    setShowActionDropdown(false);
  };

  const handleDeleteSelected = async () => {
    if (selectedItems.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Selection',
        text: 'Please select items to delete',
        confirmButtonColor: '#004aad',
      });
      return;
    }

    const result = await Swal.fire({
      title: 'Delete Selected Items?',
      text: `Are you sure you want to delete ${selectedItems.length} item(s)?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete them!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        await Promise.all(
          selectedItems.map((id) =>
            api.delete(`/inventory/stock-material/${id}/delete/`)
          )
        );
        await fetchMaterials();
      } catch (error) {
        // 🔥 Frontend-only: remove from local state
        console.warn('⚠️ Backend not ready, deleting from local state');
        setMaterials((prev) => prev.filter((m) => !selectedItems.includes(m.id)));
      }
      setSelectedItems([]);
      setShowActionDropdown(false);
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: `${selectedItems.length} item(s) deleted successfully!`,
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  const handleClearAll = () => {
    setSelectedItems([]);
    setShowActionDropdown(false);
  };

  // ==========================================
  // NAVIGATE TO ADD / EDIT PAGE
  // ==========================================
  const handleAddNew = () => {
    const shopIdToUse = selectedShop || urlShopId;
    if (shopIdToUse) {
      navigate(`/shop/${shopIdToUse}/AddStockMaterial`);
    } else {
      navigate('/AddStockMaterial');
    }
  };

  const handleEdit = (material) => {
    const shopIdToUse = selectedShop || urlShopId;
    if (shopIdToUse) {
      navigate(`/shop/${shopIdToUse}/AddStockMaterial`, {
        state: { editData: material },
      });
    } else {
      navigate('/AddStockMaterial', { state: { editData: material } });
    }
  };

  const handleDelete = async (itemId) => {
    const result = await Swal.fire({
      title: 'Delete Record?',
      text: 'Are you sure you want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/inventory/stock-material/${itemId}/delete/`);
        await fetchMaterials();
      } catch (error) {
        // 🔥 Frontend-only: remove from local state
        console.warn('⚠️ Backend not ready, deleting from local state');
        setMaterials((prev) => prev.filter((m) => m.id !== itemId));
      }
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'Record deleted successfully!',
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  const handleClickOutside = (e) => {
    if (showActionDropdown && !e.target.closest('.sm-action-dropdown-container')) {
      setShowActionDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showActionDropdown]);

  // ==========================================
  // RENDER
  // ==========================================
  return (
    <div className="stockmaterial-main-container">
      {/* ===== HEADER: Title LEFT, Controls RIGHT (same as Notes page) ===== */}
      <div className="sm-header-section">
        <div className="sm-header-left">
          <h2 className="sm-header-title">
            <FaBoxes className="sm-title-icon" />
            <span>Stock Material</span>
          </h2>

          {/* ✅ City count badge */}
          <span className="sm-city-badge">
            <FaMapMarkerAlt className="sm-city-badge-icon" />
            {selectedCityLabel} ({selectedCityCount})
          </span>
        </div>

        <div className="sm-header-right">
          <div className="sm-city-wrapper">
            <select
              className="sm-city-select"
              value={headerCity}
              onChange={(e) => { setHeaderCity(e.target.value); setSelectedItems([]); }}
              disabled={loadingHeaderCities || displayCities.length === 0}
            >
              <option value="">
                {loadingHeaderCities ? 'Loading...' : `All Cities (${totalCount})`}
              </option>
              {displayCities.map((city, index) => (
                <option key={index} value={city}>
                  {city} ({cityCounts[normCity(city)] || 0})
                </option>
              ))}
            </select>
            <IoMdArrowDropdown className="sm-city-dropdown-arrow" />
          </div>

          <div className="sm-search-wrapper">
            <FaSearch className="sm-search-icon" />
            <input
              type="text"
              placeholder="Search by invoice, supplier, material..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="sm-search-input"
            />
          </div>

          <button className="sm-select-all-btn" onClick={handleSelectAll}>
            <FaCheckDouble />
            <span>
              {selectedItems.length === filteredMaterials.length &&
              filteredMaterials.length > 0
                ? 'Deselect All'
                : 'Select All'}
            </span>
          </button>
          <button className="sm-add-btn" onClick={handleAddNew}>
            <FaPlus />
            <span>ADD NEW MATERIAL</span>
          </button>
        </div>
      </div>

      <div className="sm-content">
        {/* Selected Summary */}
        {selectedItems.length > 0 && (
          <div className="sm-selected-summary">
            <div className="sm-summary-content">
              <span className="sm-summary-icon">✓</span>
              <span className="sm-summary-text">
                {selectedItems.length} item(s) selected
              </span>
              <div className="sm-action-dropdown-container">
                <button
                  className="sm-action-dropdown-btn"
                  onClick={() => setShowActionDropdown(!showActionDropdown)}
                >
                  <FaEllipsisV />
                  <span>Actions</span>
                </button>
                {showActionDropdown && (
                  <div className="sm-action-dropdown-menu">
                    <button
                      className="sm-dropdown-item sm-delete-item"
                      onClick={handleDeleteSelected}
                    >
                      <FaTrash />
                      <span>Delete Selected ({selectedItems.length})</span>
                    </button>
                  </div>
                )}
              </div>
              <button className="sm-clear-selection" onClick={handleClearAll}>
                Clear all
              </button>
            </div>
          </div>
        )}

        {/* ===== TABLE ===== */}
        <div className="sm-table-container">
          <div className="sm-table-wrapper">
            {filteredMaterials.length > 0 ? (
              <table className="sm-table">
                <thead>
                  <tr>
                    <th style={{ width: '50px' }}>
                      <input
                        type="checkbox"
                        checked={
                          selectedItems.length === filteredMaterials.length &&
                          filteredMaterials.length > 0
                        }
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>Received Date</th>
                    <th>Invoice No</th>
                    <th>Material Spec</th>
                    <th>Supplier</th>
                    <th>Ref No</th>
                    <th>Lot Num</th>
                    <th>Int. Lot</th>
                    <th>Type</th>
                    <th>Unit</th>
                    <th>Qty Recv</th>
                    <th>Fault</th>
                    <th>After Insp.</th>
                    <th>City</th>
                    <th style={{ width: '110px' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMaterials.map((m) => (
                    <tr
                      key={m.id}
                      className={selectedItems.includes(m.id) ? 'selected' : ''}
                    >
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedItems.includes(m.id)}
                          onChange={() => handleSelectItem(m.id)}
                        />
                      </td>
                      <td>{m.received_date || '-'}</td>
                      <td>{m.invoice_no || '-'}</td>
                      <td>{m.material_specification || '-'}</td>
                      <td>{m.supplier_name || '-'}</td>
                      <td>{m.reference_no || '-'}</td>
                      <td>{m.material_lot_num || '-'}</td>
                      <td>{m.internal_lot_number || '-'}</td>
                      <td>{m.material_type || '-'}</td>
                      <td>{m.unit || '-'}</td>
                      <td>{m.quantity_received || 0}</td>
                      <td>{m.fault_pieces || 0}</td>
                      <td>{m.after_inspection_final_stock || 0}</td>
                      <td>{m.city || '-'}</td>
                      <td className="sm-actions-cell">
                        <button
                          className="sm-edit-btn"
                          onClick={() => handleEdit(m)}
                          title="Edit"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="sm-delete-btn"
                          onClick={() => handleDelete(m.id)}
                          title="Delete"
                        >
                          <RiDeleteBin5Fill />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : dataLoaded ? (
              <div className="sm-no-items">
                <FaBoxes className="sm-no-data-icon" />
                <p>
                  {!isAllCities
                    ? `No stock material records found for city "${headerCity}".`
                    : 'No stock material records found.'}
                </p>
                <button className="sm-add-first-btn" onClick={handleAddNew}>
                  <FaPlus /> Add Your First Material
                </button>
              </div>
            ) : (
              <div style={{ minHeight: '300px' }}></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockMaterial;